"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentPropertyType = exports.selectPreviewSchema = exports.selectSchemaLoading = exports.selectPostSections = exports.selectCommonFields = exports.setCurrentPropertyType = exports.fetchSchemaFailure = exports.fetchPreviewSchemaSuccess = exports.fetchPostSchemaSuccess = exports.fetchingSchema = exports.getPreviewSchema = exports.getPostSchema = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
var postSlice_1 = require("./postSlice");
var PostSectionTypes_1 = require("../../constants/PostSectionTypes");
var initialState = {
    postSchema: undefined,
    previewSchema: undefined,
    loading: false,
    error: undefined,
    currentPropertyType: PostSectionTypes_1.POST_SECTION_TYPES.APARTMENT_INFO,
};
var schemaSlice = toolkit_1.createSlice({
    name: 'post',
    initialState: initialState,
    reducers: {
        fetchingSchema: function (state) {
            state.loading = true;
        },
        fetchPostSchemaSuccess: function (state, action) {
            state.loading = false;
            state.postSchema = action.payload;
        },
        fetchPreviewSchemaSuccess: function (state, action) {
            state.loading = false;
            state.previewSchema = action.payload;
        },
        fetchSchemaFailure: function (state) {
            state.loading = false;
        },
        setCurrentPropertyType: function (state, action) {
            state.currentPropertyType = action.payload;
        },
    },
});
var getPostSchema = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingSchema());
                    return [4 /*yield*/, axios_1.default.get('/api/schema/post', {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.fetchPostSchemaSuccess(data));
                    return [2 /*return*/, data];
                case 2:
                    e_1 = _a.sent();
                    dispatch(exports.fetchSchemaFailure());
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getPostSchema = getPostSchema;
var getPreviewSchema = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingSchema());
                    return [4 /*yield*/, axios_1.default.get('/api/schema/preview', {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.fetchPreviewSchemaSuccess(data));
                    return [2 /*return*/, data];
                case 2:
                    e_2 = _a.sent();
                    dispatch(exports.fetchSchemaFailure());
                    throw e_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getPreviewSchema = getPreviewSchema;
exports.fetchingSchema = (_a = schemaSlice.actions, _a.fetchingSchema), exports.fetchPostSchemaSuccess = _a.fetchPostSchemaSuccess, exports.fetchPreviewSchemaSuccess = _a.fetchPreviewSchemaSuccess, exports.fetchSchemaFailure = _a.fetchSchemaFailure, exports.setCurrentPropertyType = _a.setCurrentPropertyType;
var selectCommonFields = function (state) {
    if (!state.schema.postSchema) {
        return {};
    }
    return state.schema.postSchema.personal.common;
};
exports.selectCommonFields = selectCommonFields;
var selectPostSections = function (state) {
    var schema = state.schema.postSchema;
    var post = postSlice_1.selectCurrentPost(state);
    if (!schema) {
        return [];
    }
    return lodash_1.default.cloneDeep((post === null || post === void 0 ? void 0 : post.isDeveloper) ? schema.developer.sections : schema.personal.sections);
};
exports.selectPostSections = selectPostSections;
var selectSchemaLoading = function (state) {
    return state.schema.loading;
};
exports.selectSchemaLoading = selectSchemaLoading;
var selectPreviewSchema = function (state) {
    return state.schema.previewSchema;
};
exports.selectPreviewSchema = selectPreviewSchema;
var selectCurrentPropertyType = function (state) {
    return state.schema.currentPropertyType;
};
exports.selectCurrentPropertyType = selectCurrentPropertyType;
exports.default = schemaSlice.reducer;
